import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faGitHub } from "@fortawesome/free-solid-svg-icons";
import {
  faAppStore,
  faGooglePlay,
  // faLinkedin,
  // faGitSquare,
  // faTwitterSquare,
  // faFacebookSquare,
} from "@fortawesome/free-brands-svg-icons";
import Banner from "../../components/common/banner";
import Footer from "../../components/common/footer";
import CanvasContainer from "../../components/common/canvasParticles";
import styles from "./landingPage.module.scss";

const LandingPage = (props) => {
  // const { location, history } = props;

  // const bannerImage = {
  //   background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))",
  //   backgroundImage: `url(${imageUrl})`,
  // };
  const imageUrl =
    "https://firebasestorage.googleapis.com/v0/b/noosaapp.appspot.com/o/assets%2Fbanner_image_form.png?alt=media";

  return (
    <div className={styles.landingContainer} style={{ overflowY: "auto" }}>
      <Banner
        heading="The Noosa App"
        subHeading="WTDNoosa"
        imageUrl={imageUrl}
      />
      <div className={styles.landingBody}>
        <div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appLinkContainer}
            href="https://apps.apple.com/au/app/wtd-noosa/id1561416158"
          >
            <span className={styles.title}>Get The App</span>
            <hr />
            <div className={styles.title}>
              <FontAwesomeIcon size="lg" color="#000000" icon={faAppStore} />{" "}
              App Store
            </div>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appLinkContainer}
            href="https://play.google.com/store/apps/details?id=com.noosaapp"
          >
            <span className={styles.title}>Get The App</span>
            <hr />
            <div className={styles.title}>
              <FontAwesomeIcon size="lg" color="#000000" icon={faGooglePlay} />{" "}
              Google Play
            </div>
          </a>
        </div>
        <Link to="/support" className={styles.linkContainer}>
          <span className={styles.title}>Support</span>
        </Link>
        <Link to="/faqs" className={styles.linkContainer}>
          <span className={styles.title}>FAQ's</span>
        </Link>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkContainer}
          href="https://www.privacypolicies.com/live/419b341a-490b-4104-9d30-7f355e51ea8b"
        >
          <span className={styles.title}>Privacy Policy</span>
        </a>
      </div>
      <CanvasContainer />
      <Footer />
    </div>
  );
};

export default withRouter(LandingPage);
